import React from 'react';
import nemesisLogo from '../../res/FullShieldCrop.png';
import '../../style/logo.scss'
function NemesisLogo() {
  return (
    <div className="logo">
      <h1>SEASON 17</h1>
      <div className={`homeBanner shimmer`}>NEMESIS</div>
      <img className="nemesisLogo" src={nemesisLogo} alt="N E M E S I S Logo" />
    </div>
  );
}

export default NemesisLogo;
